import { useGetByTenantAccountQuery } from '@/api'
import { Table } from '@/components/core-v2'
import { TENANT } from '@/const'
import { useUser } from '@/utilities/hooks/useUser'

import { getUserDisplayInfo, isCollateralUser } from '../../../tradebuilder-v2/util/user'
import { useFilteredAccounts } from '../../utils/useFilteredAccounts'
import { COLUMN_DEFS, DEFAULT_COLUMN_OPTIONS } from './columns'
import classes from './index.module.scss'
import { Loading } from './Loading'

export const TradesTable = () => {
  const { data: user } = useUser()
  const { userRoles } = getUserDisplayInfo(user)
  const { isFetching, isLoading } = useGetByTenantAccountQuery({
    tenant: TENANT
  })

  const accounts = useFilteredAccounts()

  if (isLoading || isFetching) return <Loading />

  return (
    <Table
      agGridProps={{
        context: { collateralUser: isCollateralUser(userRoles) },
        columnDefs: COLUMN_DEFS,
        defaultColDef: DEFAULT_COLUMN_OPTIONS,
        headerHeight: 60,
        rowData: accounts,
        rowHeight: 88
      }}
      className={classes.root}
    />
  )
}
